import { from } from "env-var"; // logger

const env = from(process.env, {});
const API_KEY = env.get("VUE_APP_TOKEN_API").required().asString();

export default function authHeader() {
  //let token_api = process.env.VUE_APP_TOKEN_API;
  if (API_KEY) {
    return { Authorization: "Bearer " + API_KEY };
  } else {
    return {};
  }
}
